import { render, staticRenderFns } from "./JoLoadMore.vue?vue&type=template&id=401a259c&scoped=true&"
import script from "./JoLoadMore.vue?vue&type=script&lang=js&"
export * from "./JoLoadMore.vue?vue&type=script&lang=js&"
import style0 from "./JoLoadMore.vue?vue&type=style&index=0&id=401a259c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a259c",
  null
  
)

export default component.exports